import { Grid } from '@mui/material';
import { HSpacer, RoutalPalette } from '@nx-smartmonkey/ui';
import { useIntl } from 'react-intl';

import { NotificationPill } from '.';
import IconNorthStar from '../../../../../assets/img/shared/icon-northStar.svg';
import { SubscribeIcon } from '../../../../../assets/svg/home-notifications/SubscribeIcon';
import Button from '../../../../../react-components/Button';

interface SubscribeNotificationPillProps {
  onClick: () => void;
}

export const SubscribeNotificationPill = ({ onClick }: SubscribeNotificationPillProps) => {
  const intl = useIntl();
  return (
    <NotificationPill
      notification={{
        icon: <SubscribeIcon color={RoutalPalette.upgradeColors.medium} />,
        titleIntlId: `drivers.home_notification.subscribe.title`,
        messageIntlId: `drivers.home_notification.subscribe.message`,
      }}
    >
      <Grid container direction="row" justifyContent="center" alignItems="center" style={{ marginTop: `8px` }}>
        <Button
          styleType="primary"
          style={{
            height: `35px`,
            width: `100%`,
            fontSize: `14px`,
            fontWeight: `normal`,
            borderRadius: `10px`,
            margin: 0,
            border: 0,
            backgroundColor: RoutalPalette.upgradeColors.medium,
          }}
          onClick={onClick}
        >
          {intl.formatMessage({ id: `drivers.home_notification.subscribe.button` })}
          <HSpacer small />
          <img src={IconNorthStar} alt="NorthStar" style={{ height: `15px`, width: `15px` }} />
        </Button>
      </Grid>
    </NotificationPill>
  );
};
